type IconSellCloudProps = {
    className?: string;
};

export function IconSellCloud(props: IconSellCloudProps) {
    const { className = '' } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden={true}
            className={`${className}`}
        >
            <mask
                id="mask0_6947_18935"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_6947_18935)">
                <path
                    d="M6 22H8.975C8.75833 21.7167 8.575 21.4083 8.425 21.075C8.275 20.7417 8.15833 20.3833 8.075 20H6L5.975 9.075H6L11.05 4L15.975 9.075V12.025C16.325 12.025 16.6667 12.0542 17 12.1125C17.3333 12.1708 17.6583 12.2667 17.975 12.4V9.1C17.9917 8.83333 17.95 8.57917 17.85 8.3375C17.75 8.09583 17.6083 7.875 17.425 7.675L12.475 2.6C12.275 2.4 12.0542 2.25 11.8125 2.15C11.5708 2.05 11.3167 2 11.05 2C10.8 2 10.55 2.05 10.3 2.15C10.05 2.25 9.83333 2.4 9.65 2.6L4.575 7.675C4.39167 7.85833 4.25 8.06667 4.15 8.3C4.05 8.53333 4 8.79167 4 9.075V20C4 20.5833 4.1875 21.0625 4.5625 21.4375C4.9375 21.8125 5.41667 22 6 22ZM11 9.025C10.5833 9.025 10.2375 8.87917 9.9625 8.5875C9.6875 8.29583 9.53333 7.94167 9.5 7.525C9.53333 7.10833 9.6875 6.75417 9.9625 6.4625C10.2375 6.17083 10.5833 6.025 11 6.025C11.4167 6.025 11.7583 6.17083 12.025 6.4625C12.2917 6.75417 12.45 7.10833 12.5 7.525C12.45 7.94167 12.2917 8.29583 12.025 8.5875C11.7583 8.87917 11.4167 9.025 11 9.025ZM13 22C12.15 22 11.4375 21.7125 10.8625 21.1375C10.2875 20.5625 10 19.85 10 19C10 18.2 10.275 17.5125 10.825 16.9375C11.375 16.3625 12.05 16.0583 12.85 16.025C13.1167 15.425 13.5292 14.9375 14.0875 14.5625C14.6458 14.1875 15.2583 14 15.925 14C16.7083 14 17.4208 14.2208 18.0625 14.6625C18.7042 15.1042 19.125 15.7167 19.325 16.5C20.075 16.5 20.7083 16.7708 21.225 17.3125C21.7417 17.8542 22 18.5 22 19.25C22 20 21.7625 20.6458 21.2875 21.1875C20.8125 21.7292 20.2167 22 19.5 22H13ZM13 20H19.25C19.45 20 19.625 19.9292 19.775 19.7875C19.925 19.6458 20 19.4667 20 19.25C20 19.05 19.925 18.875 19.775 18.725C19.625 18.575 19.45 18.5 19.25 18.5H17.825L17.4 17.075C17.3167 16.7417 17.1417 16.4792 16.875 16.2875C16.6083 16.0958 16.3083 16 15.975 16C15.6917 16 15.4292 16.0833 15.1875 16.25C14.9458 16.4167 14.7667 16.625 14.65 16.875L14.15 18H13C12.7167 18 12.4792 18.0958 12.2875 18.2875C12.0958 18.4792 12 18.7167 12 19C12 19.2833 12.0958 19.5208 12.2875 19.7125C12.4792 19.9042 12.7167 20 13 20Z"
                    fill="black"
                />
            </g>
        </svg>
    );
}

export default IconSellCloud;
